<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>TISCHEN UND THEKEN AUS NATURSTEIN</h1>
       <!--  <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Neben den klassischen Einsatzbereichen von Naturstein fertigen wir in unserer Werkstatt in Mönchengladbach auch einzigartige Naturstein-Unikate wie Couchtische, Esstische, Beistelltische und auch Thekenanlagen für Vereinsheime, Bars oder auch den heimischen Partykeller. Ob Einzelstück, Kleinserie oder Großserie: Bei uns erhalten Sie immer ein Unikat, dass individuell auf Ihre Vorstellungen und Bedürfnisse hin angefertigt und eingebaut wird.</p>
        <hr>
        <h2>Verleihen Sie Ihrem Umfeld das ästhetische Äußere</h2>
        <p>Dank modernster Technik sind wir in der Lage Natursteine hervorragend und millimetergenau zu verarbeiten. Ein Vorteil, der sich vor allem bei den meist individuellen Thekenanlagen aus Naturstein oder Quarzkomposit bezahlt macht. <router-link :to="{ name: 'Kontakt' }">Gerne beraten wir Sie über die verschiedenen Möglichkeiten</router-link> und finden gemeinsam mit Ihnen die passende Lösung für Ihre Ansprüche. Von der Planung und dem Design über die Auswahl des geeigneten Materials bis hin zur fachgerechten Verlegung und Montage, stehen wir Ihnen als kompetenter Partner mit langjähriger Erfahrung stets zur Seite.</p>
        <hr>
        <div class="image-row">
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/tische_theken/tische_theken01.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/tische_theken/tische_theken02.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/tische_theken/tische_theken03.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/tische_theken_mosaik_01.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/tische_theken_mosaik_02.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/tische_theken_mosaik_03.jpg"></div>
        </div>
        </article>
        </div>
    </section>
</template>

<script>
export default {
    name: "TischeTheken",
    metaInfo: {
        title: "Tische und Theken aus Naturstein",
        meta: [
            {
                vmid: "description",
                name: "description",
                content:
                    "Wir fertigen in unserer Werkstatt in Mönchengladbach auch einzigartige Naturstein-Unikate wie Couchtische, Esstische, Beistelltische und auch Thekenanlagen an"
            },
            {
                vmid: "keywords",
                name: "keywords",
                content:
                    "Naturstein Tische, Naturstein Theken, Naturstein Couchtisch, Naturstein Esstisch, Natursteintisch, Naturstein Thekenanlage, Naturstein Beistelltisch, Natursteintheke,Naturstein Mönchengladbach"
            }
        ],
        links: [
            {
                rel: "canonical",
                href: "https://www.marmor-kunze.de/naturstein-tische-und-theken"
            }
        ]
    }
};
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/TischeTheken.vue